// UI State Machine for panel visibility and layout
// DESKTOP-FIRST: No mobile/tablet viewport handling

export const UIStates = {
  DESKTOP_FULL: 'desktop_full',
  DESKTOP_CENTER_ONLY: 'desktop_center_only',
  DESKTOP_LEFT_ONLY: 'desktop_left_only',
  DESKTOP_RIGHT_ONLY: 'desktop_right_only',
  FOCUS_MODE: 'focus_mode'
};

export const UIEvents = {
  TOGGLE_LEFT: 'toggle_left',
  TOGGLE_RIGHT: 'toggle_right',
  OPEN_LEFT: 'open_left',
  OPEN_RIGHT: 'open_right',
  CLOSE_LEFT: 'close_left',
  CLOSE_RIGHT: 'close_right',
  ENTER_FOCUS: 'enter_focus',
  EXIT_FOCUS: 'exit_focus',
  OPEN_ALL: 'open_all'
};

export class UIPanelStateMachine {
  constructor() {
    this.state = {
      leftPanelOpen: true,
      rightPanelOpen: true,
      focusMode: false
    };
  }

  dispatch(event, payload) {
    const prevState = { ...this.state };

    switch (event) {
      case UIEvents.TOGGLE_LEFT:
        this.state.leftPanelOpen = !this.state.leftPanelOpen;
        break;
      case UIEvents.TOGGLE_RIGHT:
        this.state.rightPanelOpen = !this.state.rightPanelOpen;
        break;
      case UIEvents.OPEN_LEFT:
        this.state.leftPanelOpen = true;
        break;
      case UIEvents.OPEN_RIGHT:
        this.state.rightPanelOpen = true;
        break;
      case UIEvents.CLOSE_LEFT:
        this.state.leftPanelOpen = false;
        break;
      case UIEvents.CLOSE_RIGHT:
        this.state.rightPanelOpen = false;
        break;
      case UIEvents.ENTER_FOCUS:
        // Focus mode: temporarily hides both panels
        this.state.focusMode = true;
        // Store previous state for restoration
        this._prevLeftOpen = this.state.leftPanelOpen;
        this._prevRightOpen = this.state.rightPanelOpen;
        this.state.leftPanelOpen = false;
        this.state.rightPanelOpen = false;
        break;
      case UIEvents.EXIT_FOCUS:
        // Restore panels when exiting focus mode
        this.state.focusMode = false;
        // Restore previous panel state or default to open
        this.state.leftPanelOpen = this._prevLeftOpen ?? true;
        this.state.rightPanelOpen = this._prevRightOpen ?? true;
        break;
      case UIEvents.OPEN_ALL:
        this.state.leftPanelOpen = true;
        this.state.rightPanelOpen = true;
        break;
      default:
        break;
    }

    return { prevState, newState: { ...this.state } };
  }

  getComputedState() {
    if (this.state.focusMode) return UIStates.FOCUS_MODE;
    
    if (this.state.leftPanelOpen && this.state.rightPanelOpen) {
      return UIStates.DESKTOP_FULL;
    }
    if (this.state.leftPanelOpen) return UIStates.DESKTOP_LEFT_ONLY;
    if (this.state.rightPanelOpen) return UIStates.DESKTOP_RIGHT_ONLY;
    return UIStates.DESKTOP_CENTER_ONLY;
  }

  persist() {
    try {
      localStorage.setItem('smf_ui_state', JSON.stringify(this.state));
    } catch (e) {
      console.warn('Failed to persist UI state', e);
    }
  }

  restore() {
    try {
      const stored = localStorage.getItem('smf_ui_state');
      if (stored) {
        const parsed = JSON.parse(stored);
        // Only restore panel state, not focus mode
        this.state.leftPanelOpen = parsed.leftPanelOpen ?? true;
        this.state.rightPanelOpen = parsed.rightPanelOpen ?? true;
        this.state.focusMode = false; // Always start without focus mode
      }
    } catch (e) {
      console.warn('Failed to restore UI state', e);
    }
  }
}
